export default "__VITE_ASSET__RVaKEzB0__"